<template>
    <div>
        <buttonlist
                @help="help"
                @opentable="opentable"
                @search="search"
                @reflash="reflash"
                @exps="exps"
                @print="print"
                ref="SetBtn"
        ></buttonlist>
        <!-- <div>
        <el-button type="primary" size="mini" @click="impPrice" :disabled="!btn.batch">生成外协订单</el-button>
        <el-button type="primary" size="mini" @click="setInvalid" :disabled="!btn.batch">首道外协用料清单</el-button>
        </div> -->
        <wTable
                id="xpane-0"
                :data="dataSet"
                :loading="loading"
                queryData="SALProformaInvoiceHead"
                :filter_thousandth="['unit_price','qty_delivered','line_net_total_amount']"
                :header="tableHeader"
                :option="tableOption"
                @handleSelectionChange="handleSelectionChange"
                ref="singleTable"
        ></wTable>
        <!--<el-table
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                @selection-change="handleSelectionChange"
                header-row-class-name="headerclass"
                style="width: 100%; margin-top:0px"
        >
<el-table-column type="selection"></el-table-column>
<el-table-column show-overflow-tooltip prop="user_invoice_no" label="Invoice No"></el-table-column>
<el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[410]')"></el-table-column>
<el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[135]')"></el-table-column>
<el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')" align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="invoice_no" :label="$t('getapi[2992]')"></el-table-column>
<el-table-column show-overflow-tooltip prop="invoice_line_no" :label="$t('getapi[3668]')" align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="customer_order" :label="$t('getapi[2291]')"></el-table-column>
<el-table-column show-overflow-tooltip prop="sal_line_no" :label="$t('getapi[2840]')" align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="Contract_info" :label="$t('getapi[2693]')"></el-table-column>
<el-table-column show-overflow-tooltip prop="customer_item" :label="$t('getapi[2707]')" align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="CusPart_ID" :label="$t('getapi[2390]')"></el-table-column>
<el-table-column show-overflow-tooltip prop="Part_name" :label="$t('getapi[2653]')"></el-table-column>
<el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
<el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
<el-table-column show-overflow-tooltip prop="model" :label="$t('getapi[124]')"></el-table-column>
<el-table-column show-overflow-tooltip prop="spec" :label="$t('getapi[125]')"></el-table-column>
<el-table-column show-overflow-tooltip prop="unit_price" :label="$t('getapi[1410]')" align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="qty_delivered" :label="$t('getapi[3101]')" align="right"></el-table-column>
<el-table-column show-overflow-tooltip prop="line_net_total_amount" :label="$t('getapi[2102]')" align="right"></el-table-column>
        </el-table>-->
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="SALProformaInvoiceHead" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[6610]')" queryData="SALProformaInvoiceHead" tabNo="0" ref="ctab" @getctab="sortclick"></ctable>

        <el-dialog v-dialogDrag :visible.sync="popVisible" :title="$t('getapi[7257]')" width="70%" :close-on-click-modal="false">
        <el-button @click.native.prevent="expss"  size="mini">{{$t('getapi[922]')}}</el-button>
        <el-table
        header-row-class-name="headerclass"
        stripe
        :data="DdataSet"
        v-loading="loading"
        border
        size="mini"
        :highlight-current-row="true"
        style="width: 100%;"
        >
        <el-table-column show-overflow-tooltip prop="vender_code" :label="$t('getapi[1287]')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="so_code" :label="$t('getapi[4285]')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="routing_sequence_no" :label="$t('getapi[573]')" align="right"></el-table-column>
        <el-table-column show-overflow-tooltip prop="workproc_name" :label="$t('getapi[574]')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
        <!-- <el-table-column show-overflow-tooltip prop="货位" :label="$t('getapi[1957]')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="批号" :label="$t('getapi[1763]')"></el-table-column>
        <el-table-column show-overflow-tooltip prop="序列号" :label="$t('getapi[1764]')"></el-table-column> -->
        <el-table-column show-overflow-tooltip prop="measureunit" :label="$t('getapi[888]')"></el-table-column>
        <!-- <el-table-column show-overflow-tooltip prop="库存状态" :label="$t('getapi[]')"></el-table-column> -->
        <el-table-column show-overflow-tooltip prop="single_qty" :label="$t('getapi[4287]')" align="right"></el-table-column>
        <el-table-column show-overflow-tooltip prop="sum_qty" :label="$t('getapi[4288]')" align="right"></el-table-column>
        <el-table-column show-overflow-tooltip prop="qty_on_hand" :label="$t('getapi[2234]')" align="right"></el-table-column>
        <el-table-column show-overflow-tooltip prop="assist_qty_on_hand" :label="$t('getapi[2389]')" align="right"></el-table-column>

        </el-table>
        <el-row>
        <br/>
        <el-col :span="12">
        <span>共{{DdataSet.length}}条数据</span>
        </el-col>
        <!-- <el-col :span="12">
        <div style="text-align: right;line-height: 60px;color: #545c64;font-size: 95%;">表名/视图名称:{{ DbTbNames }}</div>
        </el-col> -->
        </el-row>

        <br/>
        <br/>

        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
        name:'3_invoiceviewprint',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3,
                    maxHeight: this.$windowSize.tableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: [], // 主表数据
                DdataSet:[],//弹框表数据
                isVisible: false, // 查询列表是否显示
                popVisible:false,//弹框显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                DbTbNames2:'',//弹框
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('invoiceviewprint'), // 当前页数据量
                SelectIndexs: 0, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                selectData: [],
                TempRow:{},
                btn:{
                    endIssue: false
                },
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function() {
            let that = this;
            that.colsort();
            that.userData = sessionStorage.getItem('userData');
            that.PlanTypeArray = Array.methods.getPlanType();
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            colsort(){
                let that = this;
                that.$loadviewfields.Fileds('SALProformaInvoiceHead',0,PFileds=>{
                    that.tableHeader=PFileds;
                });
            },
            sortclick(val){
                if(val==1){
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable(){
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6610]"),this.$t("getapi[3846]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel',true);
                //只读权
                if (that.$limits.ReadOnlyRightsView('plv2', 130, 1, that.total)) {
                    if (that.total > 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    } else {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                    }
                }
                //操作权限-查询级别
                var limits = that.$limits.OperationAuthorityView('plv2', 130, 1, that.total);
                // limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
                switch (limits) {
                    case -1:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        break;
                    case 1:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export,print');
                        break;
                    case -2:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        break;
                    case 2:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export,print');
                        break;
                    case -3:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        break;
                    case 3:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export,print');
                        break;
                    default:
                        break;
                }
                that.btnauthority();
            },
            btnauthority(){
                let that = this
                that.btn.endIssue = false
                if(that.selectData.length > 0){
                    that.btn.endIssue = true
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('invoiceviewprint',val)
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'SALProformaInvoiceHead');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.pageIndex = 1;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let token = JSON.parse(that.userData).token;
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Finance/FrmSaleInvoice/ProformaInvoice', data, function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.DataContent.length;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            //
            LookDetail(data){
                let that = this;
                that.TempRow = data;
                that.popVisible = true;
                let param = {
                Routing_Relation_No: data.Routing_Relation_No,
                vender_code: data.Vender_Code,
                so_code: data.so_code,
                qty: data.Plan_Finish_qty
                }
                that.$http.urlpost('/ISS/Order/PIssMaterialList', param, function(res) {
                    if (res.Success == 1) {
                        that.DdataSet = res.DataContent;
                        that.DbTbNames2 = res.DbTbNames;
                    }
                });

            },
            //跳转页面
            CreateOrder(){
                let that = this;
                if(that.selectData.length==0)return;
                let tmpvc = that.selectData[0].Vender_Code;
                for(let i=1;i<that.selectData.length;i++){
                    if(tmpvc!=that.selectData[i].Vender_Code){
                        that.$message.warning(that.$t('getapi[8840]'));//'所选行的供应商不是同一个供应商!'
                        return;
                    }
                }
                that.$store.commit('setSharedParams',that.selectData);
                let item = {
                    label: '外协订单管理',
                    name: 'wxorder',
                    path: '/wxorder/create',
                    url: '/wxorder/create',
                    icon: 'video-play'
                };
                this.$router.push({ path: '/wxorder/create'});
                this.$store.commit('selectMenu', item);
                this.$limits.cachePage(item)

                
            },
            print()
            {
                let that = this;
                if(that.selectData.length==0)return;
                let parmas=[];
                for(let i=0;i<that.selectData.length;i++)
                {
                    let obj={
                        so_code:that.selectData[i].user_invoice_no
                    }
                    parmas.push(obj);
                }

                that.loading = true;
                that.$refs.SetBtn.SetOneBtnEnable('print', false);
                that.$http.urlpost('/Print/XSPrint', parmas, function(res) {
                if (res.Success == 1) {
                let hrefurl = res.Key;
                window.open(hrefurl);
                }
                that.$refs.SetBtn.SetOneBtnEnable('print', true);
                that.loading = false;
                });

            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/ISS/Order/ProToIssOrderPlanViewExportToExecl', parm, function(res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "SALProformaInvoiceHead",
                    fromname: that.$t('getapi[6610]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            expss() {
                let that = this;
                let parm = {
                Routing_Relation_No: that.TempRow.Routing_Relation_No,
                vender_code: that.TempRow.Vender_Code,
                so_code: that.TempRow.so_code,
                qty: that.TempRow.Plan_Finish_qty
                }
                that.$http.urlpost('/ISS/Order/ProToIssOrderPlanViewExportToExecl', parm, function(res) {
                    if (res.Success == 1) {
                        that.popVisible = false;
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            handleSelectionChange(val){
                let that = this;
                that.selectData = val;
                that.btnauthority()
            },
            endIssue(){
                let that = this
                let arr = []
                for(let i = 0;i<that.selectData.length;i++){
                    arr = [...arr,{
                        so_code: that.selectData[i].so_code,
                        part_id: that.selectData[i].part_id
                    }]
                }
                let parm = {
                    Lists: arr
                }
                that.$http.urlpost('/Pro/SO/SOMaterilEndIssue', parm, function(res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                    }
                });
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
